export default __webpack_public_path__ + "static/media/nextinit-logo-black.1a5cf127.png";